/**
 * tax/taxForm.ts — 협업방 요청 화면 공용 입력 도우미(대출 요청 · 정부지원금 리포트 요청)
 *  숫자만 · 사업자등록번호 하이픈 · 국세청 검증 · 전화번호 하이픈
 */
export const digits = (v: string, n: number): string => v.replace(/\D/g, '').slice(0, n);
export const fmtBiz = (v: string): string => { const d = digits(v, 10); return d.length <= 3 ? d : d.length <= 5 ? `${d.slice(0, 3)}-${d.slice(3)}` : `${d.slice(0, 3)}-${d.slice(3, 5)}-${d.slice(5)}`; };
export function phone(v: string): string {
  const d = digits(v, 11);
  if (!d) return '';
  if (/^02/.test(d)) return d.length <= 2 ? d : d.length <= 5 ? `${d.slice(0, 2)}-${d.slice(2)}` : d.length <= 9 ? `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}` : `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6)}`;
  if (d.length <= 3) return d;
  if (d.length <= 7) return `${d.slice(0, 3)}-${d.slice(3)}`;
  if (d.length === 11) return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
  return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
}
/** 사업자등록번호 검증(국세청 가중치) */
/** 사업자등록번호 가운데 두 자리로 개인 · 법인(81~88 = 법인) — 화면에서 묻지 않는다(2026-10-14 지도사 「사업자번호 받으면 알잖아」) · 서버 taxLoan.kindOfBiz 와 같은 규칙 */
export function kindOfBiz(v: string): '' | '개인' | '법인' {
  const d = digits(v, 10);
  if (d.length !== 10) return '';
  const m = Number(d.slice(3, 5));
  return m >= 81 && m <= 88 ? '법인' : '개인';
}
export function bizOk(v: string): boolean {
  const b = digits(v, 10);
  if (b.length !== 10) return false;
  const w = [1, 3, 7, 1, 3, 7, 1, 3, 5];
  let s = 0;
  for (let i = 0; i < 9; i++) s += Number(b[i]) * w[i];
  s += Math.floor((Number(b[8]) * 5) / 10);
  return (10 - (s % 10)) % 10 === Number(b[9]);
}
